import { createJurisdictionHeaders } from '@/data';
import { URLS } from '@/data/config';
import { LOG_TAG_ACCOUNT_DETAILS_UPDATE } from '@/feature/verify-phone-number/utils/constants';
import { logger } from '@/utils/logging';
import { useMutation } from '@tanstack/react-query';

/**
 * Custom react query mutation hook to update user avatar
 * PUT /auth/user/avatar
 */
export const useUpdateAvatarUrl = () => {
    return useMutation({
        mutationFn: async (avatarUrl: string) => {
            const response = await fetch(`${URLS.CHAMELON_API_URL}/auth/user/avatar`, {
                method: 'PUT',
                headers: {
                    ...createJurisdictionHeaders(),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    avatar_url: avatarUrl,
                }),
            });

            let responseData;

            try {
                responseData = await response.json();
            } catch (error) {
                logger.warn(
                    LOG_TAG_ACCOUNT_DETAILS_UPDATE,
                    'Failed to parse response JSON for useUpdateAvatarUrl',
                    error
                );
                responseData = null;
            }

            if (!response.ok) {
                logger.warn(LOG_TAG_ACCOUNT_DETAILS_UPDATE, 'Error updating avatar url', responseData);
                throw new Error(responseData?.message || 'Error updating avatar url');
            }

            return responseData;
        },
    });
};
